import { red } from "@maxmilhas/hangar-components-atomic/public/styles/components/quarks/colors";

export const messageStyle = `
    display: flex;
    align-items: center;
    color: ${red};
    font-weight: 500;
    margin-bottom: 10px;
`;
